'use client';

export * from './chunk-reload';
export * from './cn';
export * from './console-log';
export * from './format-date';
export * from './get-next-simulation';
export * from './get-score-card-description';
export * from './get-score-card-subtitle';
export * from './get-user-name';
export * from './get-user-role';
export * from './map-api-availables-to-frontend';
export * from './map-api-managed-user-data-to-frontend';
export * from './map-api-manager-data-to-frontend';
export * from './map-api-scorecards-to-frontend';
export * from './map-api-simulations-to-frontend';
export * from './map-api-userbadges-to-frontend';
export * from './map-api-users-to-frontend';
export * from './map-simulation-to-roleplaycard';
export * from './map-simulation-with-history';

export { isLocalDevelopment, isLocalHost, isDevelopment, isBrowser } from './is-local-host';
